import React from 'react';
export function useAdvancedSearchErrors() {
    const [errors, setErrors] = React.useState({});
    const validate = React.useCallback((data, fields) => {
        const errorMap = {};
        if (fields) {
            fields.forEach((field) => {
                errorMap[field] = !data[field];
            });
            setErrors((prev) => (Object.assign(Object.assign({}, prev), errorMap)));
        }
        else {
            for (const key in data) {
                errorMap[key] = !data[key];
            }
            setErrors(errorMap);
        }
        return Object.values(errorMap).includes(true);
    }, []);
    const resetErrors = React.useCallback(() => {
        setErrors((prev) => {
            const result = Object.assign({}, prev);
            Object.keys(prev).forEach((key) => (result[key] = false));
            return result;
        });
    }, []);
    return { validate, resetErrors, errors };
}
